var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"bk-list clearfix",attrs:{"id":"bk-list"}},_vm._l((_vm.Books),function(Book){return _c('Book',{key:Book.ISBN,attrs:{"Data":Book}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }